var _rect, _path, _path2, _mask, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 8,
    height: 1.5,
    rx: 0.75,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3C9.75 2.86193 9.86193 2.75 10 2.75H14C14.1381 2.75 14.25 2.86193 14.25 3V6.25H9.75V3Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3V4.5H6.5V20.5H17.5V4.5H15V3H18C18.5523 3 19 3.44772 19 4V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V4C5 3.44771 5.44772 3 6 3H9Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_741_47153",
    fill: "var(--bg-surface)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 8,
    height: 6,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 8,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-4-inside-1_741_47153)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarStation);
export default __webpack_public_path__ + "static/media/sidebarStation.a4bfe610dc894273027d842de5e1a283.svg";
export { ForwardRef as ReactComponent };